/* @flow */
import React from 'react';
// $FlowIgnore
import { MdClose } from 'react-icons/md';

export default function CloseIcon({
  style
}: Object): React.Element {
  return <MdClose style={style} />;
}
